/* eslint-disable no-return-assign */
/* eslint-disable react/destructuring-assignment */
/* eslint eqeqeq: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import MUDatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import {
  Field, reduxForm, blur,
} from 'redux-form';
import styled from 'styled-components';
import LinearProgress from 'material-ui/LinearProgress';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import normalizePhone from '../../helpers/normalizePhone.js';
import { BODY_TEXT_COLOR, THIRD_COLOR, NEGATIVE_COLOR } from '../../config/colors';
import { ArrowLeft } from '../../icons';
import * as modal from '../../reducers/modalReducer';
import { formatDate, formatBirthdayForServer, setTimeZone } from '../../helpers/date';
import { enableScrollJs, disableScrollJs } from '../../helpers/scroll';
import { getConfigValue } from '../../reducers/configReducer';
import { isSmallViewPortWidth } from '../../helpers/display_util';
import {
  CUSTOMER_TYPE_ALLOW,
  DEFAULT_PATIENT_TYPE,
  GOOGLE_RECAPTCHA_SITE_KEY,
} from '../../config/const';
import { emailValidator } from '../../utils/validators/emailValidators';

import './style.css';
import ReCAPTCHA from 'react-google-recaptcha';
import { isCaptchaValidationEnabled } from '../../selectors/configSelectors.js';

const $ = require('jquery');

const required = value => (value ? undefined : 'Required');
const checkPhoneNumberValid = phoneNumber => /^([2-9][0-9]{2})-[0-9]{3}-[0-9]{4}$/g.test(phoneNumber) ? undefined : 'Must be 10 digits long and cannot start with 0 or 1';
const maxLength = max => value => (value && value.length > max ? `Must be not longer than ${max} characters` : undefined);
const maxLength45 = maxLength(45);  // VARCHAR(45) in MySQL

const styles = {
  inputStyle: { textTransform: 'capitalize' },
  closeIconWrap: {
    position: 'absolute', left: '5px', top: '10px', cursor: 'pointer',
  },
  closeIcon: { height: '50px', width: '50px', color: THIRD_COLOR },
  floatingText: { color: NEGATIVE_COLOR, fontSize: isSmallViewPortWidth() ? '15px' : '16px' },
  textField: {
    fontSize: '16px', fontWeight: '400', width: '100%', color: BODY_TEXT_COLOR, textTransformation: 'capitalize',
  },
  emailTextField: {
    fontSize: '16px', fontWeight: '400', width: '100%', color: BODY_TEXT_COLOR,
  },
  underlineStyle: { borderColor: BODY_TEXT_COLOR },
  labelStyle: { fontWeight: 700 },
  birthdayLabel: {
    color: '#afafb1', fontFamily: 'Roboto', fontSize: '18px', margin: '20px 0 5px 0',
  },
  radioButtonGroup: { marginTop: '20px' },
  birthday: {
    fontSize: '16px',
    fontWeight: '400',
    width: '100%',
    color: BODY_TEXT_COLOR,
    textTransformation: 'capitalize',
    marginBottom: '10px',
    webkitAppearance: 'none',
  },
};

class SignUpForm extends Component {

  constructor(props) {
    super(props);
    this.phoneField = null;
    this.nameField = null;
    this.emailField = null;
    this.birthdayField = null;
    this.datePickerInput = undefined;
    this.secondaryColor = ['#', this.props.secondaryColor].join('');
    this.floatingLabelStyle = { color: this.secondaryColor };
    this.floatingFocusLabelStyle = { color: this.secondaryColor };
    this.underlineFocusStyle = { borderColor: this.secondaryColor };
    this.recaptchaRef = React.createRef();
    this.state = {
      isInputAddressActive: false,
      date: null,
      isSubmitVisible: false,
      token: '',
    };
  }

   componentDidMount() {
     if (this.isSavedSignUpForm(this.props.initialValues)) {
       this.emailField.focus();
     }
   }

   isSavedSignUpForm(values) {
    return values && values.name && values.email;
   }

   validBirthday = (value) => {
     const d = new Date(Date.parse(value));
     const ageGate = this.getAgeRestriction() || 21;
     const year = d.getFullYear();
     const month = d.getMonth();
     const day = d.getDate();
     const res = new Date(year + ~~ageGate, month, day) > new Date();
     return res ? `Your age must be above ${ageGate} to proceed` : undefined;
   };

    getCurrentBirthDayDate = () => this.state.date;

    getAgeRestriction() {
      return this.props.ageRestriction;
    }

    getMaxDate() {
      return this.props.maxDate;
    }

    getBirthDateAndUpdateInputMobile(input) {
      const {
        externalSelectedDate,
      } = this.props;

      let birthDate = null;

      if (externalSelectedDate) {
        birthDate = formatBirthdayForServer(externalSelectedDate);
        input.onChange(setTimeZone(externalSelectedDate)); // triggers redux form field validation
      } else if (input.value) {
        birthDate = formatBirthdayForServer(input.value);
      }

      return birthDate;
    }

    getFormattedMaxDate = () => {
      const maxDate = this.getMaxDate();

      let dd = maxDate.getDate();
      let mm = maxDate.getMonth() + 1; // January is 0!
      const yyyy = maxDate.getFullYear();
      if (dd < 10) {
        dd = `0${dd}`;
      }
      if (mm < 10) {
        mm = `0${mm}`;
      }

      return `${yyyy}-${mm}-${dd}`;
    }

    onCloseRequest = () => {
      this.props.hideModal();
    }

    handleBackBtn = () => {
      this.props.hideModal();
      setTimeout(() => {
        this.props.openLoginForm();
      }, 5);
    }

    handleInputEnterPress = (e, inputName, touched, error) => {
      if ((e.key === 'Enter' || e.key == '13') && error === undefined) {
        if (inputName === 'name') {
          e.preventDefault();
          this.onInputBlur('name');
          setTimeout(() => {
            this.lastNameField.focus();
          }, 250);
        } else if (inputName === 'lastname') {
          e.preventDefault();
          this.onInputBlur('lastname');
          setTimeout(() => {
            this.emailField.focus();
          }, 250);
        } else if (inputName === 'email') {
          e.preventDefault();
          this.onInputBlur('email');
          setTimeout(() => {
            this.phoneField.focus();
          }, 250);
        } else if (inputName === 'phone') {
          e.preventDefault();
          this.onInputBlur('phone');
          setTimeout(() => {
            this.birthdayField.focus();
          }, 250);
        } else if (inputName === 'birthday') {
          this.onInputBlur('birthday');
          this.props.handleSubmit();
        }
      }
    }

    onInputFocus = (inputName) => {
      const { isPhone, is_iPhone } = this.props;
      if (is_iPhone) return;
      if (isPhone) {
        const height = [$('.greetigs').height() / 1.5, 'px'];
        this.setState({
          isInputAddressActive: true,
          mainContainerHeight: height.join(''),
        });
      }
    }

    onInputBlur = (inputName) => {
      const { isPhone, is_iPhone } = this.props;
      if (is_iPhone) return;
      if (isPhone) {
        this.setState({
          isInputAddressActive: false,
        });
      }
    }

   renderNameField = ({
     input, label, meta: { touched, error }, ...custom
   }) => (
     <TextField
       name="name"
       ref={input => this.nameField = input}
       onKeyPress={e => this.handleInputEnterPress(e, 'name', touched, error)}
       onFocus={() => this.onInputFocus('name')}
       onBlur={() => this.onInputBlur('name')}
       floatingLabelText={<span style={styles.floatingText}>First Name (as it appears on your ID)</span>}
       style={styles.textField}
       inputStyle={styles.inputStyle}
       floatingLabelStyle={this.floatingLabelStyle}
       floatingLabelFocusStyle={this.floatingFocusLabelStyle}
       underlineStyle={styles.underlineStyle}
       underlineFocusStyle={this.underlineFocusStyle}
       errorText={(touched && error ? error : '')}
       {...input}
       {...custom}
     />
   )

   renderLastNameField = ({
     input, label, meta: { touched, error }, ...custom
   }) => (
     <TextField
       name="lastname"
       inputStyle={styles.inputStyle}
       ref={input => this.lastNameField = input}
       onKeyPress={e => this.handleInputEnterPress(e, 'lastname', touched, error)}
       onFocus={() => this.onInputFocus('lastname')}
       onBlur={() => this.onInputBlur('lastname')}
       floatingLabelText={<span style={styles.floatingText}>Last Name (as it appears on your ID)</span>}
       style={styles.textField}
       floatingLabelStyle={this.floatingLabelStyle}
       floatingLabelFocusStyle={this.floatingFocusLabelStyle}
       underlineStyle={styles.underlineStyle}
       underlineFocusStyle={this.underlineFocusStyle}
       errorText={(touched && error ? error : '')}
       {...input}
       {...custom}
     />
   )

   renderEmailField = ({
     input, label, meta: { touched, error }, ...custom
   }) => (
     <TextField
       name="email"
       type="email"
       ref={input => this.emailField = input}
       onKeyPress={e => this.handleInputEnterPress(e, 'email', touched, error)}
       onFocus={() => this.onInputFocus('email')}
       onBlur={() => this.onInputBlur('email')}
       floatingLabelText={<span style={styles.floatingText}>Email</span>}
       style={styles.emailTextField}
       floatingLabelStyle={this.floatingLabelStyle}
       floatingLabelFocusStyle={this.floatingFocusLabelStyle}
       underlineStyle={styles.underlineStyle}
       underlineFocusStyle={this.underlineFocusStyle}
       errorText={(touched && error ? error : '')}
       {...input}
       {...custom}
     />
   )

    renderPhoneField = ({
      input, label, meta: { touched, error }, ...custom
    }) => (
      <TextField
        phone="phone"
        ref={input => this.phoneField = input}
        type="tel"
        onKeyPress={e => this.handleInputEnterPress(e, 'phone', touched, error)}
        onFocus={() => this.onInputFocus('phone')}
        onBlur={() => this.onInputBlur('phone')}
        floatingLabelText={<span style={styles.floatingText}>Phone Number</span>}
        style={styles.textField}
        floatingLabelStyle={this.floatingLabelStyle}
        floatingLabelFocusStyle={this.floatingFocusLabelStyle}
        underlineStyle={styles.underlineStyle}
        underlineFocusStyle={this.underlineFocusStyle}
        errorText={(touched && error ? error : '')}
        {...input}
        {...custom}
      />
    )

    renderTokenField = ({
      input, label, meta: { touched, error }, ...custom
    }) => {
      input.onChange(this.state.token);
      return <TextField
        name="userCaptchaResponseToken"
        type="text"
        value={this.state.token}
        readOnly
      />
    } 
      
    customerTypeChange = (e) => {
      this.props.customerTypeChange(e.target.value, () => {
        setTimeout(() => {
          this.props.blurField('birthday', null);
          this.props.blurField('birthday', this.getCurrentBirthDayDate());
        }, 100);
      });
    }

    renderCustomerType = () => {
      const { customerTypeAllowed, defaultPatientType } = this.props;
      // TODO change config value to ADULT instead of ADULTUSE
      const defaultType = defaultPatientType === 'ADULTUSE' ? 'ADULT' : defaultPatientType;
      if (customerTypeAllowed === 'ALL') {
        const adultRadio = (
          <RadioButton
            iconStyle={{ fill: `#${this.props.secondaryColor}` }}
            key="ADULT"
            value="ADULT"
            label="Adult use"
            labelStyle={{ fontSize: '15px', color: BODY_TEXT_COLOR, fontWeight: '400' }}
          />
        );
        const medicalRadio = (
          <RadioButton
            iconStyle={{ fill: `#${this.props.secondaryColor}` }}
            key="MEDICAL"
            value="MEDICAL"
            label="Medical use"
            labelStyle={{ fontSize: '15px', color: BODY_TEXT_COLOR, fontWeight: '400' }}
          />
        );
        return (
          <RadioButtonGroup
            className="signup-input-wrap"
            name="customerType"
            style={styles.radioButtonGroup}
            onChange={this.customerTypeChange}
            defaultSelected={defaultType}
          >
            {adultRadio}
            {medicalRadio}
          </RadioButtonGroup>
        );
      }
    }

    renderMobileFriendlyPicker = (input, maxDate, isAppleDevice, error) => {
      return (
        <TextField
          ref={i => this.birthdayField = i}
          type="date"
          value={this.getBirthDateAndUpdateInputMobile(input)}
          max={maxDate}
          className="date-picker"
          onClick={(event) => {
            if (!isAppleDevice) {
              event.preventDefault();
              this.props.openDatePicker();
            }
          }}
          onKeyPress={e => this.handleInputEnterPress(e, 'birthday', touched, error)}
          onFocus={() => this.onInputFocus('birthday')}
          onBlur={() => this.onInputBlur('birthday')}
          onChange={(event, date) => {
            const newValue = setTimeZone(date);
            input.onChange(newValue);
            this.setState({ date: newValue });
            this.birthdayField.blur();
          }}
          floatingLabelText={<span style={styles.floatingText}>Birthday</span>}
          style={styles.textField}
          floatingLabelStyle={this.floatingLabelStyle}
          floatingLabelFocusStyle={this.floatingFocusLabelStyle}
          underlineStyle={styles.underlineStyle}
          underlineFocusStyle={this.underlineFocusStyle}
          errorText={(error && error !== 'Required' ? error : '')}
          readOnly
        />
      );
    }

    renderBirthdayField = ({
      input, label, meta: { touched, error }, ...custom
    }) => {
      const {
        isPhone,
        is_iPhone,
      } = this.props;

      if (isPhone) {
        return this.renderMobileFriendlyPicker(
          input,
          this.getFormattedMaxDate(),
          is_iPhone,
          error,
        );
      }

      if (typeof input.value === 'string') input.value = {};
      return (
        <MUDatePicker
          {...input}
          ref={i => this.birthdayField = i}
          className="date-picker"
          selected={input.value ? new Date(input.value) : null}
          onChange={(event, value) => {
            const newValue = new Date(value);
            input.onChange(newValue);
            this.setState({ date: newValue });
          }}
          floatingLabelText={<span style={styles.floatingText}>Birthday</span>}
          style={styles.textField}
          floatingLabelStyle={this.floatingLabelStyle}
          floatingLabelFocusStyle={this.floatingFocusLabelStyle}
          underlineStyle={styles.underlineStyle}
          underlineFocusStyle={this.underlineFocusStyle}
          errorText={(touched && error ? error : '')}
          maxDate={this.getMaxDate()}
          value={input.value}
          onClick={this.datepickerClick}
          openToYearSelection
          onShow={() => enableScrollJs()}
          onDismiss={() => disableScrollJs()}
          formatDate={date => formatDate(new Date(date))
            }
        />
      );
    }

  datepickerClick = () => {
    if (this.state.date) return;
    this.setState({ date: this.getMaxDate() });
  }

  renderProgress = () => {
    if (this.props.upload.inProgress) return (<LinearProgress color="#8BC027" mode="indeterminate" />);
  }

  handleCaptchaSuccess = () => {
    const token = this.recaptchaRef.current.getValue();

    this.setState({isSubmitVisible: true, token});
  }

  handleSubmitButton = (values) => {
    const { handleSubmit } = this.props;

    handleSubmit(values);
  }

  render() {
    const {
      pristine,
      valid,
      googleRecaptchaSiteKey,
      isCaptchaValidationEnabled,
    } = this.props;

    const { isSubmitVisible, token } = this.state;

    return (
      <form name="signup" style={{ margin: '20px 0 20px', maxHeight: '85vh' }}>
        {!this.state.isInputAddressActive && <div onClick={this.handleBackBtn} style={styles.closeIconWrap}><ArrowLeft style={styles.closeIcon} /></div>}
        <FormWrapperDiv style={{ maxHeight: isSmallViewPortWidth() ? '100%' : '85vh' }}>
          {!this.state.isInputAddressActive && <HeaderDiv style={{ fontSize: isSmallViewPortWidth() ? '22px' : '35px' }}>CREATE AN ACCOUNT</HeaderDiv>}
          <div className="signup-input-wrap">
            <Field
              onFocus={() => this.onInputFocus('name')}
              onBlur={() => this.onInputBlur('name')}
              name="name"
              validate={[required], maxLength45}
              component={this.renderNameField}
            />
          </div>
          <div className="signup-input-wrap">
            <Field
              onFocus={() => this.onInputFocus('lastname')}
              onBlur={() => this.onInputBlur('lastname')}
              name="lastname"
              validate={[required], maxLength45}
              component={this.renderLastNameField}
            />
          </div>
          <div className="signup-input-wrap">
            <Field
              onFocus={() => this.onInputFocus('email')}
              onBlur={() => this.onInputBlur('email')}
              name="email"
              validate={[required, emailValidator]}
              component={this.renderEmailField}
            />
          </div>
          <div className="signup-input-wrap">
            <Field
              onFocus={() => this.onInputFocus('phone')}
              onBlur={() => this.onInputBlur('phone')}
              name="phone"
              normalize={normalizePhone}
              validate={[
                required,
                checkPhoneNumberValid,
              ]}
              component={this.renderPhoneField}
            />
          </div>
          <div className="signup-input-wrap" style={this.props.is_iPhone ? { maxHeight: '84px' } : {}}>
            <Field
              onFocus={() => this.onInputFocus('birthday')}
              onBlur={() => this.onInputBlur('birthday')}
              name="birthday"
              validate={[this.validBirthday, required]}
              component={this.renderBirthdayField}
            />
          </div>
          {token && <div className="signup-input-wrap" style={{ height: '0', opacity: '0' }}>
            <Field
              name="userCaptchaResponseToken"
              component={this.renderTokenField}
            />
          </div>
          }
          
          {this.renderCustomerType()}
          {this.renderProgress()}
          { isCaptchaValidationEnabled && 
            <div className="recaptcha-wrapper">
              <ReCAPTCHA
                ref={this.recaptchaRef}
                sitekey={googleRecaptchaSiteKey}
                onChange={() => { this.handleCaptchaSuccess() }}
              />
            </div>
          }
          
          {(isSubmitVisible || !isCaptchaValidationEnabled) && 
            <div className="submitBtn-wrapper">            
              <RaisedButton
                onClick={this.handleSubmitButton}
                disabled={pristine || !valid}
                backgroundColor={`#${this.props.secondaryColor}`}
                labelColor="#FFF"
                label="Sign up"
                fullWidth
                labelStyle={styles.labelStyle}
              />
            </div>
          }
          
        </FormWrapperDiv>
      </form>
    );
  }
}

SignUpForm.propTypes = {
  initialValues: PropTypes.objectOf(PropTypes.shape({})),
  openDatePicker: PropTypes.func.isRequired,
  externalSelectedDate: PropTypes.shape({}),
};

SignUpForm = reduxForm({
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  form: 'signupForm',
})(SignUpForm);

const mapStateToProps = state => ({
  isPhone: state.config.isPhone,
  is_iPhone: state.config.is_iPhone,
  secondaryColor: state.config.secondaryColor,
  upload: state.upload,
  customerTypeAllowed: getConfigValue(CUSTOMER_TYPE_ALLOW, state),
  defaultPatientType: getConfigValue(DEFAULT_PATIENT_TYPE, state).toUpperCase(),
  googleRecaptchaSiteKey: getConfigValue(GOOGLE_RECAPTCHA_SITE_KEY, state),
  isCaptchaValidationEnabled: isCaptchaValidationEnabled(state),
});

const mapDispatchToProps = dispatch => ({
  blurField: (fieldName, val) => dispatch(blur('signupForm', fieldName, val)),
  hideModal: () => dispatch(modal.hideModal()),
  openLoginForm: () => dispatch(modal.openModal({
    modalType: 'LOGIN_FORM',
    modalProps: {
      raisedClass: 'raise',
    },
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpForm);

const HeaderDiv = styled.div`
  font-size: 39px;
  line-height: 33px;
  font-weight: 700;
  width: 80%;
  font-family: 'Futura-Bold';
  text-align: center;
    @media (max-width: 768px) {
        width: 100%;
    }
    @media (max-width: 320px) {
        font-size: 35px;
        line-height: 35px;
    }
`;

const FormWrapperDiv = styled.div`
    display: flex;
    color: ${BODY_TEXT_COLOR};
    flex-direction: column;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    margin: 20px auto 0;
    height: 100%;
    font-family: 'Futura-Bold', 'Futura-Bold';
`;



// WEBPACK FOOTER //
// ./src/components/SignUpForm/SignUpForm.jsx